import { render, staticRenderFns } from "./ShiftsMemo.vue?vue&type=template&id=6ad0a8a6&lang=pug"
import script from "./ShiftsMemo.vue?vue&type=script&lang=js"
export * from "./ShiftsMemo.vue?vue&type=script&lang=js"
import style0 from "./ShiftsMemo.vue?vue&type=style&index=0&id=6ad0a8a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports